/**
 * @author Harshitha.k
 * @description 
 */

import React, { useState, useEffect, useRef } from 'react';
import _ from 'lodash';
import cloneDeep from 'lodash.clonedeep';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { connect } from 'react-redux';
// import { createStructuredSelector } from 'reselect';
import { Tag, TreeSelect, message } from 'antd';
import StyledTable from '../../commons/styles/table';
import styled from 'styled-components';
import { IPAddress, REPORTS } from '../../commons/api';
import SelectionComponent from './SelectionComponent';
import SelectComponennt from './SelectComponent';
import {
  getDataSourceFromBackend,
  getReportNametoDownload,
  getPdfNametoDownload,
  getReportNametoDownloadMultiVaraint
} from './ReportCalls';
// import { getTranslationCache } from '../../selectors/language';
import { getTranslatedDatasource } from './ReportAdapter';
import localStorage from '../../utils/localStorage';

import './style.css';
import { DownloadOutlined, FilePdfOutlined } from '@ant-design/icons';
const { SHOW_PARENT } = TreeSelect;
export const ChildTablesGroup = styled.div`
  background-color: #f1f1f1;
  width: 100%;
  // margin: 20px;
  text-align: center;
  line-height: 75px;
`;

const ReportTable = (props) => {
  const [columns, setColumns] = useState(props.columns || []);
  const [currentDatasource, setCurrentDatasource] = useState(props.currentDatasource || []);
  const [reportName, setReportName] = useState('');
  const [childDatasource, setChildDatasource] = useState([]);
  // const [nestedChildColumns, setNestedChildColumns] = useState(props.nestedChildColumns || []);
  const [weekSummaryDatasource, setWeekSummaryDatasource] = useState([]);
  const [tableConfiguration, setTableConfiguration] = useState({
    bordered:
      props.tableConfiguration && props.tableConfiguration.bordered
        ? props.tableConfiguration.bordered
        : true,
    horizontalScroll: props.tableConfiguration
      ? props.tableConfiguration.horizontalScroll
      : false,
    pagination: props.tableConfiguration ? props.tableConfiguration.pagination : false,
    tableSize: props.tableConfiguration ? props.tableConfiguration.tableSize : 'default',
    noResultMessage: props.tableConfiguration
      ? props.tableConfiguration.noResultMessage
      : 'No Records',
    isCursorPointer: props.tableConfiguration
      ? props.tableConfiguration.isCursorPointer
      : false,
    title: props.tableConfiguration ? props.tableConfiguration.title : '',
    pageSize: props.tableConfiguration ? props.tableConfiguration.pageSize : '10',
    downloadXLXS: props.tableConfiguration ? props.tableConfiguration.downloadXLXS : false,
    downloadExcelPayload: props.tableConfiguration
      ? props.tableConfiguration.downloadExcelPayload
      : {},
    downloadPdf: props.tableConfiguration ? props.tableConfiguration.downloadPdf : false,
    downloadPdfPayload: props.tableConfiguration
      ? props.tableConfiguration.downloadPdfPayload
      : {},
    columnFilter: props.tableConfiguration ? props.tableConfiguration.columnFilter : false,
    headerSelection: props.tableConfiguration ? props.tableConfiguration.headerSelection : [],
    style: {
      textAlign:
        props.tableConfiguration &&
          props.tableConfiguration.style &&
          props.tableConfiguration.style.textAlign
          ? props.tableConfiguration.style.textAlign
          : 'center',
      // "fontWeight": (props.tableConfiguration && props.tableConfiguration.style && props.tableConfiguration.style.fontWeight) ? props.tableConfiguration.style.fontWeight : "normal",
      evenRowColor:
        props.tableConfiguration &&
          props.tableConfiguration.style &&
          props.tableConfiguration.style.evenRowColor
          ? props.tableConfiguration.style.evenRowColor
          : 'rgb(251, 250, 250)',
      oldRowColor:
        props.tableConfiguration &&
          props.tableConfiguration.style &&
          props.tableConfiguration.style.oldRowColor
          ? props.tableConfiguration.style.oldRowColor
          : '#fff'
    },
    showStatus:
      props.tableConfiguration && props.tableConfiguration.showStatus
        ? props.tableConfiguration.showStatus
        : false,
    prepareDynamicColumns:
      props.tableConfiguration && props.tableConfiguration.prepareDynamicColumns
        ? props.tableConfiguration.prepareDynamicColumns
        : {},

  });
  const [selectionObject, setSelectionObject] = useState({
    Month: moment().format('MMMM'),
    Year: moment().year()
  });
  const [selectedDevice, setSelectedDevice] = useState('FRM_1_TRBN_1');
  const [treeData, setTreeData] = useState([]);
  const [value, setValue] = useState([]);
  const [language, setLanguage] = useState(props.CurrentLanguage || 'English');
  const [summaryValue, setSummaryValue] = useState([]);
  const [summaryTable, setSummaryTable] = useState([]);
  const [TagsList, setTagsList] = useState([]);
  const [pdfName, setPdfName] = useState('');
  const [api, setApi] = useState(props.api || []);
  const [initalRender, setInitalRender] = useState({
    initalRender: true,
    optionList: []
  });
  const [filteredInfo, setFilteredInfo] = useState(null);
  const timeTicketRef = useRef(null);
  const selectionWidget = useState(props.selectionWidget || {});

  useEffect(() => {
    const refreshTime = props.tableConfiguration?.pageRefreshFrequency || 1440;
    if (timeTicketRef.current) {
      clearInterval(timeTicketRef.current);
    }
    _getDataSource();
    timeTicketRef.current = setInterval(() => {
      _getDataSource();
    }, refreshTime * 60000);
    return () => {
      if (timeTicketRef.current) {
        clearInterval(timeTicketRef.current);
      }
    };
  }, [props.tableConfiguration]);

  useEffect(() => {
    const currentLanguage = localStorage.get('currentLanguage');
    if (props.CurrentLanguage !== currentLanguage) {
      props.onChangeLang(currentLanguage);
      setLanguage(currentLanguage);
      _getDataSource();
    }
    if (api !== props.api ||
      reportName !== props.reportName) {
      _getDataSource();
      setTableConfiguration(prev => ({
        ...prev,
        tableConfiguration: {
          bordered:
            props.tableConfiguration && props.tableConfiguration.bordered
              ? props.tableConfiguration.bordered
              : true,
          pagination:
            props.tableConfiguration && props.tableConfiguration.pagination
              ? props.tableConfiguration.pagination
              : false,
          horizontalScroll: props.tableConfiguration
            ? props.tableConfiguration.horizontalScroll
            : false,
          tableSize: props.tableConfiguration
            ? props.tableConfiguration.tableSize
            : 'default',
          noResultMessage: props.tableConfiguration
            ? props.tableConfiguration.noResultMessage
            : 'No Records',
          isCursorPointer: props.tableConfiguration
            ? props.tableConfiguration.isCursorPointer
            : false,
          title: props.tableConfiguration ? props.tableConfiguration.title : '',
          pageSize: props.tableConfiguration ? props.tableConfiguration.pageSize : '10',
          downloadXLXS: props.tableConfiguration
            ? props.tableConfiguration.downloadXLXS
            : false,
          downloadExcelPayload: props.tableConfiguration
            ? props.tableConfiguration.downloadExcelPayload
            : {},
          downloadPdf: props.tableConfiguration
            ? props.tableConfiguration.downloadPdf
            : false,
          downloadPdfPayload: props.tableConfiguration
            ? props.tableConfiguration.downloadPdfPayload
            : {},
          columnFilter: props.tableConfiguration
            ? props.tableConfiguration.columnFilter
            : false,
          headerSelection: props.tableConfiguration
            ? props.tableConfiguration.headerSelection
            : [],
          style: {
            textAlign:
              props.tableConfiguration &&
                props.tableConfiguration.style &&
                props.tableConfiguration.style.textAlign
                ? props.tableConfiguration.style.textAlign
                : 'center',
            // "fontWeight": (props.tableConfiguration && props.tableConfiguration.style && props.tableConfiguration.style.fontWeight) ? props.tableConfiguration.style.fontWeight : "normal",
            evenRowColor:
              props.tableConfiguration &&
                props.tableConfiguration.style &&
                props.tableConfiguration.style.evenRowColor
                ? props.tableConfiguration.style.evenRowColor
                : 'rgb(251, 250, 250)',
            oldRowColor:
              props.tableConfiguration &&
                props.tableConfiguration.style &&
                props.tableConfiguration.style.oldRowColor
                ? props.tableConfiguration.style.oldRowColor
                : '#fff'
          },
          showStatus:
            props.tableConfiguration && props.tableConfiguration.showStatus
              ? props.tableConfiguration.showStatus
              : false
        }
      }));
    }

    if (language !== props.language) {
      _getDataSource();
    }
  }, [
    props.CurrentLanguage,
    props.api,
    props.reportName,
    props.language
  ]);

  const _generateTreeData = (columns) => {
    let treeData =
      columns &&
      Array.isArray(columns) &&
      columns.map((columnData) => {
        value.push(columnData.key);
        return {
          ...columnData,
          children: [],
          value: columnData.key
        };
      });
    let summaryValue = value.filter(
      (e) => e !== 'Date' && e !== 'Total Consumption With Losses' && e !== 'Total Cost per KWH'
    );
    return {
      treeData,
      value,
      summaryValue: ['Summary', ...summaryValue]
    };
  };

  const _getDataSource = async () => {
    let summaryTableClone = [];
    let api = cloneDeep({
      ...props.api,
      payload: {
        ...(props.api && props.api.payload ? props.api.payload : {}),
        AssetCode: props.AssetCode
      }
    });
    let columnsClone = cloneDeep(props.columns);
    let multiVaraintColumns = cloneDeep(props.nestedChildColumns || []);
    columnsClone = await getTranslatedDatasource(columnsClone, props.translationCache);
    let { selectionWidget, childTable, weekSummaryTable, tableConfiguration } = props;
    summaryTableClone = childTable && childTable[0] && childTable[0].columns || [];

    if (childTable && childTable[0] && childTable[0].columns) {
      summaryTableClone = await getTranslatedDatasource(childTable[0].columns, props.translationCache);
    }

    // Column validation logic
    if (api && api.payload && api.payload.isEquipment && api.payload.isEquipment === 'no') {
      columnsClone = await columnValidation(columnsClone, 'no');
    } else {
      columnsClone = await columnValidation(columnsClone, 'yes');
    }

    let treeDataNew = await _generateTreeData(columnsClone);
    setColumns(columnsClone);
    setTreeData(treeDataNew.treeData);
    setValue(treeDataNew.value);
    setSummaryValue(treeDataNew.summaryValue);

    // Selection object logic
    let month = moment().month();
    let year = moment().year();
    let selectionObjectClone = {};

    if (selectionWidget?.payload) {
      Object.keys(selectionWidget.payload).forEach((payloadParams, key) => {
        if (key <= 1 && key === 0) {
          let payloadItem = selectionWidget.payload[payloadParams];
          selectionObjectClone[`${payloadParams}`] = moment([year, month])
            .startOf('month')
            .utc()
            .format(payloadItem.format);
          if (selectionWidget.widget === 'year-picker') {
            selectionObjectClone[`${payloadParams}`] = moment([year])
              .startOf('year')
              .utc()
              .format(payloadItem.format);
          } else if (selectionWidget.widget === 'date-picker') {
            selectionObjectClone[`${payloadParams}`] = moment()
              .subtract(1, 'day')
              .startOf('day')
              .utc()
              .format(payloadItem.format);
          }
          if (selectionWidget.widget === 'dateRange-picker') {
            selectionObjectClone[`${payloadParams}`] = moment()
              .subtract(30, 'days')
              .format(payloadItem.format);
          }
          if (selectionWidget.widget === 'weak-picker') {
            selectionObjectClone[`${payloadParams}`] = moment()
              .startOf('week')
              .utc()
              .format(payloadItem.format);
          }
        } else if (key <= 1 && key === 1) {
          let payloadItem = selectionWidget.payload[payloadParams];
          selectionObjectClone[`${payloadParams}`] = moment([year, month])
            .endOf('months')
            .utc()
            .format(payloadItem.format);
          if (selectionWidget.widget === 'year-picker') {
            selectionObjectClone[`${payloadParams}`] = moment([year])
              .endOf('years')
              .utc()
              .format(payloadItem.format);
          } else if (selectionWidget.widget === 'date-picker') {
            selectionObjectClone[`${payloadParams}`] = moment()
              .endOf('day')
              .subtract(1, 'day')
              .utc()
              .format(payloadItem.format);
          }
          if (selectionWidget.widget === 'dateRange-picker') {
            selectionObjectClone[`${payloadParams}`] = moment().format(payloadItem.format);
          }
          if (selectionWidget.widget === 'weak-picker') {
            selectionObjectClone[`${payloadParams}`] = moment()
              .endOf('week')
              .utc()
              .format(payloadItem.format);
          }
        }
        if (payloadParams === 'month') {
          selectionObjectClone[`${payloadParams}`] = moment().format('MMMM');
        }
        if (payloadParams === 'year') {
          selectionObjectClone[`${payloadParams}`] = year;
        }
        if (payloadParams === 'Date') {
          selectionObjectClone[`${payloadParams}`] = moment().subtract('day', 1).format('YYYY-MM-DD');
        }
      });
    }

    let TagsListClone = columnsClone &&
      Array.isArray(columnsClone) &&
      columnsClone.map((columnsData) => columnsData.key);
    if (api) {
      if (tableConfiguration &&
        tableConfiguration.columnFilter &&
        tableConfiguration.columnFilter === 'true') {
        api.payload = {
          ...api.payload,
          ...selectionObjectClone,
          ...selectionObject,
          language,
          TagsList: TagsListClone.filter(
            (e) => e !== 'Date' && e !== 'Total Consumption With Losses' && e !== 'Total Cost per KWH'
          )
        };
      } else {
        api.payload = {
          ...api.payload,
          ...selectionObjectClone,
          language,
          DeviceCode: selectedDevice
        };
      }
    }

    let childDatasourceClone = [];
    if (childTable && childTable[0] && childTable[0].api) {
      if (tableConfiguration &&
        tableConfiguration.columnFilter &&
        tableConfiguration.columnFilter === 'true'
      ) {
        childTable[0].api.payload = {
          ...childTable[0].api.payload,
          ...selectionObjectClone,
          ...selectionObject,
          TagsList: TagsListClone.filter(
            (e) => e !== 'Date' && e !== 'Total Consumption With Losses' && e !== 'Total Cost per KWH'
          )
        };
      } else {
        childTable[0].api.payload = {
          ...childTable[0].api.payload,
          ...selectionObjectClone,
          ...selectionObject
        };
      }

      childDatasourceClone = await getDataSourceFromBackend(childTable[0].api);
      setChildDatasource(childDatasourceClone);
    }

    // API for week summary
    let weekSummaryDatasourceClone = [];
    if (weekSummaryTable && weekSummaryTable.api) {
      if (tableConfiguration &&
        tableConfiguration.columnFilter &&
        tableConfiguration.columnFilter === 'true') {
        weekSummaryTable.api.payload = {
          ...weekSummaryTable.api.payload,
          ...selectionObjectClone,
          ...selectionObject,
          TagsList: TagsListClone.filter(
            (e) => e !== 'Date' && e !== 'Total Consumption With Losses' && e !== 'Total Cost per KWH'
          )
        };
      } else {
        weekSummaryTable.api.payload = {
          ...weekSummaryTable.api.payload,
          ...selectionObjectClone,
          ...selectionObject
        };
      }

      weekSummaryDatasourceClone = await getDataSourceFromBackend(weekSummaryTable.api);
      setWeekSummaryDatasource(weekSummaryDatasourceClone);
    }

    let filteredInfoClone = filteredInfo || {};
    
    let currentDatasourceClone = await getDataSourceFromBackend(api);
    if (
      tableConfiguration &&
      tableConfiguration.prepareDynamicColumns &&
      tableConfiguration.prepareDynamicColumns.enable &&
      tableConfiguration.prepareDynamicColumns.enable === true &&
      currentDatasourceClone &&
      currentDatasourceClone[0]
    ) {
      columnsClone = generateColumnsFromDatasource(currentDatasourceClone[0]);
      let reportNameClone = await getReportNametoDownload(
        columnsClone,
        currentDatasourceClone,
        tableConfiguration.downloadExcelPayload,
        childTable && childTable[0] && childTable[0].columns ? childTable[0].columns : [],
        childDatasourceClone,
        weekSummaryDatasourceClone,
        {
          SelectedDate:
            moment.utc(selectionObject.startDate).local().format('YYYY-MM-DD HH:mm') +
            '~' +
            moment.utc(selectionObject.endDate).local().format('YYYY-MM-DD HH:mm')
        },
        tableConfiguration
      );
      let treeDataNewClone = await _generateTreeData(columnsClone);
      setReportName(reportNameClone);
      setColumns(columnsClone);
      setValue(treeDataNewClone.value);
    }

    if (currentDatasourceClone && Array.isArray(currentDatasourceClone)) {
      columnsClone.forEach((columnsObject, i) => {
        if (columnsObject?.filter) {
          let filterOptions = currentDatasourceClone
            .map((datasource) => {
              if (datasource[columnsClone[i].key] !== null) {
                return {
                  text: datasource[columnsClone[i].key],
                  value: datasource[columnsClone[i].key]
                };
              }
              return {};
            })
            .filter(Boolean);
          columnsClone[i] = {
            ...columnsObject,
            filters: _.uniqBy(filterOptions, (e) => e.text),
            filteredValue: filteredInfoClone[columnsClone[i].key] || null,
            onFilter: (value, record) => record[columnsClone[i].key].includes(value),
            ellipsis: true
          };
        }
        if (columnsObject && columnsObject.key === 'Action') {
          columnsClone[i] = {
            ...columnsObject,
            render: () => (
              <a href="/#" target="_blank" rel="noopener noreferrer">
                action
              </a>
            )
          };
        }
      });
    }

    let reportNameClone = '';
    let pdfNameClone = '';
    if (
      tableConfiguration &&
      tableConfiguration.downloadXLXS &&
      (tableConfiguration.downloadXLXS === true ||
        tableConfiguration.downloadXLXS === 'true')
    ) {
      if (tableConfiguration.downloadExcelPayload &&
        tableConfiguration.downloadExcelPayload.summaryType &&
        (tableConfiguration.downloadExcelPayload.summaryType === 'true' ||
          tableConfiguration.downloadExcelPayload.summaryType === true) &&
        childTable &&
        childTable[0] &&
        childTable[0].columns
      ) {
        reportNameClone = await getReportNametoDownload(
          columnsClone,
          currentDatasourceClone,
          tableConfiguration.downloadExcelPayload,
          childTable[0].columns,
          childDatasourceClone,
          weekSummaryDatasourceClone,
          {
            SelectedDate: moment.utc(selectionObject.startDate).local().format('YYYY-MM-DD HH:mm') +
              '~' +
              moment.utc(selectionObject.endDate).local().format('YYYY-MM-DD HH:mm')
          },
          tableConfiguration
        );
      } else if (props.nestedChildColumns) {
        reportNameClone = await getReportNametoDownloadMultiVaraint(
          columnsClone,
          currentDatasourceClone,
          multiVaraintColumns,
          tableConfiguration.downloadExcelPayload
        );
      } else {
        reportNameClone = await getReportNametoDownload(
          columnsClone,
          currentDatasourceClone,
          tableConfiguration.downloadExcelPayload,
          childTable?.[0]?.columns || [],
          childDatasourceClone,
          weekSummaryDatasourceClone,
          {
            SelectedDate: moment.utc(selectionObject.startDate).local().format('YYYY-MM-DD HH:mm') +
              '~' +
              moment.utc(selectionObject.endDate).local().format('YYYY-MM-DD HH:mm')
          },
          tableConfiguration
        );
      }
      setCurrentDatasource(currentDatasourceClone);
      setSummaryTable(summaryTableClone);
      setReportName(reportNameClone && reportNameClone.file ? reportNameClone.file : '');
      setApi(api);
      setSelectionObject(selectionObject);
    } else {
      setCurrentDatasource(currentDatasourceClone);
      setSummaryTable(summaryTable);
      setTagsList(TagsListClone);
      setApi(api);
      setSelectionObject(selectionObject);
    }

    if (tableConfiguration &&
      tableConfiguration.downloadPdf &&
      (tableConfiguration.downloadPdf === true ||
        tableConfiguration.downloadPdf === 'true')) {
      if (
        tableConfiguration.downloadPdfPayload &&
        tableConfiguration.downloadPdfPayload.summaryType &&
        (tableConfiguration.downloadPdfPayload.summaryType === 'true' ||
          tableConfiguration.downloadPdfPayload.summaryType === true) &&
        childTable &&
        childTable[0] &&
        childTable[0].columns
      ) {
        pdfNameClone = await getPdfNametoDownload(
          columnsClone,
          currentDatasourceClone,
          tableConfiguration.downloadPdfPayload,
          childTable[0].columns,
          childDatasourceClone,
          weekSummaryDatasourceClone
        );
      } else {
        pdfNameClone = await getPdfNametoDownload(
          columnsClone,
          currentDatasourceClone,
          tableConfiguration.downloadPdfPayload
        );
      }
      setCurrentDatasource(currentDatasourceClone);
      setSummaryTable(summaryTable);
      setPdfName(pdfNameClone && pdfNameClone.file ? pdfNameClone.file : '');
      setApi(api);
      setSelectionObject(selectionObject);
    } else {
      setCurrentDatasource(currentDatasourceClone);
      setSummaryTable(summaryTable);
      setTagsList(TagsListClone);
      setApi(api);
      setSelectionObject(selectionObject);
    }
  };

  const getPlusThreeNumbersUntilTotal = (start, total, span) => {
    let result = [];
    let current = start;

    while (current <= total) {
      result.push(current);
      current += span;
    }

    return result;
  };

  const generateColumnsFromDatasource = (currentDatasources) => {
    let { colSpanProp } = tableConfiguration.prepareDynamicColumns || {};
    let ObjectData = Object.keys(currentDatasources);
    let newData = ObjectData.filter(
      (e) =>
        !(
          tableConfiguration.prepareDynamicColumns &&
            tableConfiguration.prepareDynamicColumns.excludeKeys
            ? tableConfiguration.prepareDynamicColumns.excludeKeys
            : []
        ).includes(e)
    ).map((inputString) => {
      const keys = inputString.split('$$$');
      let array = keys.map((val) => {
        const keyData = val.split(':Color');
        return {
          title: keyData.length === 2 ? keyData[0] : val,
          dataIndex: inputString,
          key: inputString,
          width:
            tableConfiguration &&
              tableConfiguration.prepareDynamicColumns &&
              tableConfiguration.prepareDynamicColumns.fixedWidth
              ? tableConfiguration.prepareDynamicColumns.fixedWidth
              : 100,
          //   "colSpanProp": {
          //     "field": "Date",
          //     "show": true,
          //     "span": 3,
          //     "totalRows": 100
          // }
          ...(colSpanProp && colSpanProp.show === true && colSpanProp.field === inputString
            ? {
              ...{
                onCell: (_, index) => {
                  let totalList = getPlusThreeNumbersUntilTotal(
                    0,
                    colSpanProp ? colSpanProp.totalRows : 100,
                    colSpanProp ? colSpanProp.span : 0
                  );
                  if (totalList.includes(index)) {
                    return {
                      rowSpan: colSpanProp ? colSpanProp.span : 0
                    };
                  }
                  return {
                    rowSpan: 0
                  };
                }
              }
            }
            : {}),
          render(text) {
            // "enable": true,
            // "isUTCColumns": [
            //     "Date"
            // ],
            // "isUTCFormat":"YYYY-MM-DD",
            // "fixedWidth": 200,
            // applyBackgroundColor:true

            return {
              // props: {
              //   style: { background: '#214972' }
              // },
              children: (
                <div
                  style={{
                    color:
                      keyData.length === 2
                        ? text !== undefined
                          ? text
                          : 'rgb(33, 73, 114)'
                        : 'white',
                    fontWeight: 'bold',
                    backgroundColor:
                      tableConfiguration &&
                        tableConfiguration.prepareDynamicColumns &&
                        tableConfiguration.prepareDynamicColumns.applyBackgroundColor &&
                        tableConfiguration.prepareDynamicColumns.applyBackgroundColor === true &&
                        keyData.length === 2
                        ? text
                        : 'none'
                  }}
                >
                  {text !== 'null' && keyData.length !== 2
                    ? tableConfiguration &&
                      tableConfiguration.prepareDynamicColumns &&
                      tableConfiguration.prepareDynamicColumns.isUTCColumns &&
                      tableConfiguration.prepareDynamicColumns.isUTCColumns.length > 0 &&
                      tableConfiguration.prepareDynamicColumns.isUTCColumns.includes(inputString)
                      ? text === 'Total' || text === 'Average'
                        ? text
                        : text && text !== null
                          ? moment
                            .utc(text)
                            .local()
                            .format(
                              tableConfiguration &&
                                tableConfiguration.prepareDynamicColumns &&
                                tableConfiguration.prepareDynamicColumns.isUTCFormat
                                ? tableConfiguration.prepareDynamicColumns.isUTCFormat
                                : 'YYYY-MM-DD HH:mm:ss'
                            )
                          : null
                      : text
                    : '______'}
                </div>
              )
            };
          }
        };
      });

      let nested = array.reduceRight((a, b, index) => {
        let object = { ...b, children: [] };
        object.children.push({
          ...(index === 0 ? a : { ...a, dataIndex: inputString, key: inputString })
        });
        return object;
      });

      return nested;
    });
    let noDupes = PrepareChildren(newData);
    let removeAnotherLevelDupes =
      noDupes &&
      Array.isArray(noDupes) &&
      noDupes.map((trainObject) => {
        let children = PrepareChildren(trainObject.children);
        let obj = {
          ...trainObject,
          children
        };
        return obj;
      });
    return removeAnotherLevelDupes;
  };

  const PrepareChildren = (newData) => {
    const noDupes =
      newData &&
      newData.reduce((noDupesArray, currentItem) => {
        const parent = noDupesArray.find((parent) => parent.title === currentItem.title);

        if (parent) {
          if (!parent.children && currentItem.children) {
            parent.children = [];
          }
          currentItem.children.forEach((currentItemChild) => {
            // const childExists = parent.children.some((child) => child.title === currentItemChild.title);
            parent.children.push(currentItemChild);
          });
        } else {
          noDupesArray.push(currentItem);
        }

        return noDupesArray;
      }, []);
    return noDupes;
  };

  const columnValidation = (columnsData, columnValue) => {
    let newObj =
      columnsData &&
      Array.isArray(columnsData) &&
      columnsData.filter((columns) => {
        if (columns && !columns.noEquipment && !columns.yesEquipment) {
          return columns;
        }
        if (columnValue === 'no') {
          return columns && columns.noEquipment === true;
        } else if (columnValue === 'yes') {
          return columns && columns.yesEquipment === true;
        }
        return {};
      });
    return newObj;
  };

  const selectionPayloadHandler = async (selectionPayload) => {
    let weekSummaryTable = cloneDeep(props.weekSummaryTable);
    let { childTable, tableConfiguration } = props;
    let { headerSelection } = tableConfiguration;
    let clonedColumns = cloneDeep(columns);
    let TagsList = clonedColumns.map((columnData) => columnData.key);

    if (headerSelection && headerSelection[0]) {
      const { defaultValue, key } = headerSelection[0];
      if (defaultValue && key) {
        api.payload = {
          ...api.payload,
          ...selectionPayload,
          [key]: defaultValue,
        };
      }
    }

    if (
      tableConfiguration &&
      tableConfiguration.columnFilter &&
      tableConfiguration.columnFilter === 'true'
    ) {
      api.payload = {
        ...api.payload,
        ...selectionPayload,
        TagsList: TagsList.filter(
          (e) => e !== 'Date' && e !== 'Total Consumption With Losses' && e !== 'Total Cost per KWH'
        ),
      };
    } else {
      api.payload = {
        ...api.payload,
        ...selectionPayload,
      };
    }

    if (childTable && childTable[0] && childTable[0].api) {
      if (tableConfiguration && tableConfiguration.columnFilter && tableConfiguration.columnFilter === 'true') {
        childTable[0].api.payload = {
          ...childTable[0].api.payload,
          ...selectionPayload,
          TagsList: TagsList.filter(
            (e) => e !== 'Date' && e !== 'Total Consumption With Losses' && e !== 'Total Cost per KWH'
          ),
        };
      } else {
        childTable[0].api.payload = {
          ...childTable[0].api.payload,
          ...selectionPayload,
        };
      }

      const fetchedChildDatasource = await getDataSourceFromBackend(childTable[0].api);
      setChildDatasource(fetchedChildDatasource);
    }

    if (weekSummaryTable && weekSummaryTable.api) {
      if (tableConfiguration && tableConfiguration.columnFilter && tableConfiguration.columnFilter === 'true') {
        weekSummaryTable.api.payload = {
          ...weekSummaryTable.api.payload,
          ...selectionPayload,
          TagsList: TagsList.filter(
            (e) => e !== 'Date' && e !== 'Total Consumption With Losses' && e !== 'Total Cost per KWH'
          ),
        };
      } else {
        weekSummaryTable.api.payload = {
          ...weekSummaryTable.api.payload,
          ...selectionPayload,
        };
      }

      const fetchedWeekSummaryDatasource = await getDataSourceFromBackend(weekSummaryTable.api);
      setWeekSummaryDatasource(fetchedWeekSummaryDatasource);
    }

    const fetchedCurrentDatasource = await getDataSourceFromBackend(api);
    if (
      tableConfiguration &&
      tableConfiguration.prepareDynamicColumns &&
      tableConfiguration.prepareDynamicColumns.enable &&
      tableConfiguration.prepareDynamicColumns.enable === true &&
      fetchedCurrentDatasource &&
      fetchedCurrentDatasource[0]
    ) {
      const newColumns = generateColumnsFromDatasource(fetchedCurrentDatasource[0]);
      const reportName = await getReportNametoDownload(
        newColumns,
        fetchedCurrentDatasource,
        props.tableConfiguration.downloadExcelPayload,
        childTable?.[0]?.columns || [],
        childDatasource,
        weekSummaryDatasource,
        {
          SelectedDate: `${moment.utc(selectionObject.startDate).local().format('YYYY-MM-DD HH:mm')}~${moment.utc(selectionObject.endDate).local().format('YYYY-MM-DD HH:mm')}`,
        },
        tableConfiguration
      );
      const treeDataNew = await _generateTreeData(newColumns);
      setReportName(reportName);
      setColumns(newColumns);
      setValue(treeDataNew.value);
    }

    // Handle multi-variant columns
    let multiVariantColumns = cloneDeep(props.nestedChildColumns);
    if (fetchedCurrentDatasource && Array.isArray(fetchedCurrentDatasource)) {
      clonedColumns.forEach((columnObject, i) => {
        if (columnObject && columnObject.filter && columnObject.filter === true) {
          const filterOptions = fetchedCurrentDatasource
            .map((datasource) => datasource[columnObject.key] ? {
              text: datasource[columnObject.key],
              value: datasource[columnObject.key],
            } : null)
            .filter(Boolean);
          clonedColumns[i] = {
            ...columnObject,
            filters: _.uniqBy(filterOptions, 'text'),
          };
        } else if (columnObject?.key === 'Action') {
          clonedColumns[i] = {
            ...columnObject,
            render: () => <a href="/#" target="_blank">action</a>,
          };
        }
      });
    }

    // Handle Excel download
    if (tableConfiguration &&
      tableConfiguration.downloadXLXS &&
      (tableConfiguration.downloadXLXS === true ||
        tableConfiguration.downloadXLXS === 'true')) {
      let reportName = '';
      if (tableConfiguration.downloadExcelPayload &&
        tableConfiguration.downloadExcelPayload.summaryType &&
        tableConfiguration.downloadExcelPayload.summaryType === 'true' &&
        childTable &&
        childTable[0] &&
        childTable[0].columns) {
        reportName = await getReportNametoDownload(
          clonedColumns,
          fetchedCurrentDatasource,
          tableConfiguration.downloadExcelPayload,
          childTable[0].columns,
          childDatasource,
          weekSummaryDatasource,
          {
            SelectedDate: `${moment.utc(selectionPayload.startDate).local().format('YYYY-MM-DD HH:mm')}~${moment.utc(selectionPayload.endDate).local().format('YYYY-MM-DD HH:mm')}`,
          },
          tableConfiguration
        );
      } else if (props.nestedChildColumns) {
        reportName = await getReportNametoDownloadMultiVaraint(
          clonedColumns,
          fetchedCurrentDatasource,
          multiVariantColumns,
          tableConfiguration.downloadExcelPayload
        );
      } else {
        reportName = await getReportNametoDownload(
          clonedColumns,
          fetchedCurrentDatasource,
          tableConfiguration.downloadExcelPayload,
          childTable?.[0]?.columns || [],
          childDatasource,
          weekSummaryDatasource,
          {
            SelectedDate: `${moment.utc(selectionPayload.startDate).local().format('YYYY-MM-DD HH:mm')}~${moment.utc(selectionPayload.endDate).local().format('YYYY-MM-DD HH:mm')}`,
          },
          tableConfiguration
        );
      }
      setCurrentDatasource(fetchedCurrentDatasource);
      setSelectionObject(selectionPayload);
      setReportName(reportName && reportName.file ? reportName.file : '');
      setColumns(clonedColumns);
    } else {
      setCurrentDatasource(fetchedCurrentDatasource);
      setWeekSummaryDatasource(weekSummaryDatasource);
      setSelectionObject(selectionPayload);
      setColumns(clonedColumns);
      setApi(api);
    }

    // Handle PDF download
    if (tableConfiguration &&
      tableConfiguration.downloadPdf &&
      (tableConfiguration.downloadPdf === true ||
        tableConfiguration.downloadPdf === 'true')) {
      let pdfNameClone = '';
      if (tableConfiguration.downloadPdfPayload &&
        tableConfiguration.downloadPdfPayload.summaryType &&
        tableConfiguration.downloadPdfPayload.summaryType === 'true' &&
        childTable &&
        childTable[0] &&
        childTable[0].columns) {
        pdfNameClone = await getPdfNametoDownload(
          clonedColumns,
          fetchedCurrentDatasource,
          tableConfiguration.downloadPdfPayload,
          childTable[0].columns,
          childDatasource,
          weekSummaryDatasource
        );
      } else {
        pdfNameClone = await getPdfNametoDownload(
          clonedColumns,
          fetchedCurrentDatasource,
          tableConfiguration.downloadPdfPayload
        );
      }
      setCurrentDatasource(fetchedCurrentDatasource);
      setSelectionObject(selectionPayload);
      setPdfName(pdfNameClone && pdfNameClone.file ? pdfNameClone.file : '');
    } else {
      setCurrentDatasource(fetchedCurrentDatasource);
      setWeekSummaryDatasource(weekSummaryDatasource);
      setSelectionObject(selectionPayload);
      setApi(api);
    }
  };

  const onChange = async (newValue) => {
    await onTagChange(newValue);
    newValue = ['Date', ...newValue, 'Total'];
    let newSummaryValue = ['Summary', ...newValue, 'Total'];
    setValue(newValue);
    setSummaryValue(newSummaryValue);
  };

  const onTagChange = async (TagsList) => {
    let api = cloneDeep(props.api);
    let selectionObjectClone = { ...selectionObject };
    let { childTable, tableConfiguration } = props;
    let weekSummaryTable = props.weekSummaryTable;

    if (tableConfiguration && tableConfiguration.columnFilter && tableConfiguration.columnFilter === 'true') {
      api.payload = {
        ...api.payload,
        ...selectionObjectClone,
        TagsList: TagsList.filter(
          (e) => e !== 'Date' && e !== 'Total Consumption With Losses' && e !== 'Total Cost per KWH'
        ),
      };
    } else {
      api.payload = {
        ...api.payload,
        ...selectionObjectClone,
      };
    }

    let fetchedChildDatasource = [];
    if (childTable && childTable[0]?.api) {
      if (tableConfiguration && tableConfiguration.columnFilter && tableConfiguration.columnFilter === 'true') {
        childTable[0].api.payload = {
          ...childTable[0].api.payload,
          ...selectionObjectClone,
          TagsList: TagsList.filter(
            (e) => e !== 'Date' && e !== 'Total Consumption With Losses' && e !== 'Total Cost per KWH'
          ),
        };
      } else {
        childTable[0].api.payload = {
          ...childTable[0].api.payload,
          ...selectionObjectClone,
        };
      }

      fetchedChildDatasource = await getDataSourceFromBackend(childTable[0].api);
      setChildDatasource(fetchedChildDatasource);
    }

    // API for week summary
    let fetchedWeekSummaryDatasource = [];
    if (weekSummaryTable?.api) {
      if (tableConfiguration && tableConfiguration.columnFilter && tableConfiguration.columnFilter === 'true') {
        weekSummaryTable.api.payload = {
          ...weekSummaryTable.api.payload,
          ...selectionObjectClone,
          TagsList: TagsList.filter(
            (e) => e !== 'Date' && e !== 'Total Consumption With Losses' && e !== 'Total Cost per KWH'
          ),
        };
      } else {
        weekSummaryTable.api.payload = {
          ...weekSummaryTable.api.payload,
          ...selectionObjectClone,
        };
      }

      fetchedWeekSummaryDatasource = await getDataSourceFromBackend(weekSummaryTable.api);
      setWeekSummaryDatasource(fetchedWeekSummaryDatasource);
    }

    let multiVariantColumns = cloneDeep(props.nestedChildColumns);
    let fetchedCurrentDatasource = await getDataSourceFromBackend(api);
    if (tableConfiguration?.prepareDynamicColumns?.enable && fetchedCurrentDatasource?.[0]) {
      const newColumns = generateColumnsFromDatasource(fetchedCurrentDatasource[0]);
      const reportName = await getReportNametoDownload(
        newColumns,
        fetchedCurrentDatasource,
        props.tableConfiguration.downloadExcelPayload,
        childTable?.[0]?.columns || [],
        fetchedChildDatasource,
        fetchedWeekSummaryDatasource,
        {
          SelectedDate: `${moment.utc(selectionObjectClone.startDate).local().format('YYYY-MM-DD HH:mm')}~${moment.utc(selectionObjectClone.endDate).local().format('YYYY-MM-DD HH:mm')}`,
        },
        tableConfiguration
      );
      const treeDataNew = await _generateTreeData(newColumns);
      setReportName(reportName);
      setColumns(newColumns);
      setValue(treeDataNew.value);
    }

    // Handle Excel download
    if (props.tableConfiguration?.downloadXLXS) {
      let reportName = '';
      if (props.tableConfiguration.downloadExcelPayload?.summaryType === 'true' && childTable?.[0]?.columns) {
        reportName = await getReportNametoDownload(
          columns,
          fetchedCurrentDatasource,
          props.tableConfiguration.downloadExcelPayload,
          childTable[0].columns,
          fetchedChildDatasource,
          fetchedWeekSummaryDatasource,
          {
            SelectedDate: `${moment.utc(selectionObjectClone.startDate).local().format('YYYY-MM-DD HH:mm')}~${moment.utc(selectionObjectClone.endDate).local().format('YYYY-MM-DD HH:mm')}`,
          },
          tableConfiguration
        );
      } else if (props.nestedChildColumns) {
        reportName = await getReportNametoDownloadMultiVaraint(
          columns,
          fetchedCurrentDatasource,
          multiVariantColumns,
          props.tableConfiguration.downloadExcelPayload
        );
      } else {
        reportName = await getReportNametoDownload(
          columns,
          fetchedCurrentDatasource,
          props.tableConfiguration.downloadExcelPayload,
          childTable?.[0]?.columns || [],
          fetchedChildDatasource,
          fetchedWeekSummaryDatasource,
          {
            SelectedDate: `${moment.utc(selectionObjectClone.startDate).local().format('YYYY-MM-DD HH:mm')}~${moment.utc(selectionObjectClone.endDate).local().format('YYYY-MM-DD HH:mm')}`,
          },
          tableConfiguration
        );
      }
      setCurrentDatasource(fetchedCurrentDatasource);
      setReportName(reportName?.file || '');
    } else {
      setCurrentDatasource(fetchedCurrentDatasource);
    }

    // Handle PDF download
    if (props.tableConfiguration?.downloadPdf) {
      let pdfName = '';
      if (props.tableConfiguration.downloadPdfPayload?.summaryType === 'true' && childTable?.[0]?.columns) {
        pdfName = await getPdfNametoDownload(
          columns,
          fetchedCurrentDatasource,
          props.tableConfiguration.downloadPdfPayload,
          childTable[0].columns,
          fetchedChildDatasource,
          fetchedWeekSummaryDatasource
        );
      } else {
        pdfName = await getPdfNametoDownload(
          columns,
          fetchedCurrentDatasource,
          props.tableConfiguration.downloadPdfPayload
        );
      }
      setCurrentDatasource(fetchedCurrentDatasource);
      setPdfName(pdfName?.file || '');
    } else {
      setCurrentDatasource(fetchedCurrentDatasource);
    }
  };

  const onSelectionChange = async (TagsList) => {
    let api = cloneDeep(props.api);
    let year = moment().year();
    let payload = {};

    const { selectionWidget } = props;

    if (selectionWidget && selectionWidget.payload) {
      Object.keys(selectionWidget.payload).forEach((payloadParams, key) => {
        if (key <= 1) {
          payload[payloadParams] = key === 0 ? selectionObject.startDate : selectionObject.endDate;

          if (selectionWidget.widget === 'year-picker' || selectionWidget.widget === 'date-picker' || selectionWidget.widget === 'dateRange-picker' || selectionWidget.widget === 'weak-picker') {
            payload[payloadParams] = key === 0 ? selectionObject.startDate : selectionObject.endDate;
          }
        }

        if (payloadParams === 'month') {
          payload[payloadParams] = moment().format('MMMM');
        }

        if (payloadParams === 'year') {
          payload[payloadParams] = year;
        }

        if (payloadParams === 'Date') {
          payload[payloadParams] = moment().subtract(1, 'day').format('YYYY-MM-DD');
        }
      });
    }

    api.payload = {
      ...api.payload,
      ...payload,
      ...TagsList,
    };

    // Fetch child datasource
    if (props.childTable && props.childTable[0]?.api) {
      props.childTable[0].api.payload = {
        ...props.childTable[0].api.payload,
        ...payload,
        ...TagsList,
      };
      const fetchedChildDatasource = await getDataSourceFromBackend(props.childTable[0].api);
      setChildDatasource(fetchedChildDatasource);
    }

    // Fetch week summary datasource
    if (props.weekSummaryTable && props.weekSummaryTable.api) {
      props.weekSummaryTable.api.payload = {
        ...props.weekSummaryTable.api.payload,
        ...payload,
        ...TagsList,
      };
      const fetchedWeekSummaryDatasource = await getDataSourceFromBackend(props.weekSummaryTable.api);
      setWeekSummaryDatasource(fetchedWeekSummaryDatasource);
    }

    // Fetch current datasource
    const fetchedCurrentDatasource = await getDataSourceFromBackend(api);
    const { tableConfiguration } = props;

    if (tableConfiguration?.prepareDynamicColumns?.enable && fetchedCurrentDatasource?.[0]) {
      const newColumns = generateColumnsFromDatasource(fetchedCurrentDatasource[0]);
      const reportName = await getReportNametoDownload(
        newColumns,
        fetchedCurrentDatasource,
        props.tableConfiguration.downloadExcelPayload,
        props.childTable?.[0]?.columns || [],
        childDatasource,
        weekSummaryDatasource,
        {
          SelectedDate: `${moment.utc(selectionObject.startDate).local().format('YYYY-MM-DD HH:mm')}~${moment.utc(selectionObject.endDate).local().format('YYYY-MM-DD HH:mm')}`,
        },
        tableConfiguration
      );
      const treeDataNew = await _generateTreeData(newColumns);
      setColumns(newColumns);
      setReportName(reportName);
      // Assuming you have a way to set the value
      setValue(treeDataNew.value);
    }

    // Update columns with filters
    if (Array.isArray(fetchedCurrentDatasource)) {
      const updatedColumns = columns.map((columnObject) => {
        if (columnObject?.filter) {
          const filters = fetchedCurrentDatasource
            .map((datasource) => datasource[columnObject.key] ? {
              text: datasource[columnObject.key],
              value: datasource[columnObject.key],
            } : null)
            .filter(Boolean);
          return {
            ...columnObject,
            filters,
          };
        }
        return columnObject;
      });
      setColumns(updatedColumns);
    }

    // Handle Excel download
    if (props.tableConfiguration?.downloadXLXS) {
      let reportName = '';
      if (props.tableConfiguration.downloadExcelPayload?.summaryType === 'true' && props.childTable?.[0]?.columns) {
        reportName = await getReportNametoDownload(
          columns,
          fetchedCurrentDatasource,
          props.tableConfiguration.downloadExcelPayload,
          props.childTable[0].columns,
          childDatasource,
          weekSummaryDatasource,
          {
            SelectedDate: `${moment.utc(selectionObject.startDate).local().format('YYYY-MM-DD HH:mm')}~${moment.utc(selectionObject.endDate).local().format('YYYY-MM-DD HH:mm')}`,
          },
          tableConfiguration
        );
      } else if (props.nestedChildColumns) {
        const multiVariantColumns = cloneDeep(props.nestedChildColumns);
        reportName = await getReportNametoDownloadMultiVaraint(
          columns,
          fetchedCurrentDatasource,
          multiVariantColumns,
          props.tableConfiguration.downloadExcelPayload
        );
      } else {
        reportName = await getReportNametoDownload(
          columns,
          fetchedCurrentDatasource,
          props.tableConfiguration.downloadExcelPayload,
          props.childTable?.[0]?.columns || [],
          childDatasource,
          weekSummaryDatasource,
          {
            SelectedDate: `${moment.utc(selectionObject.startDate).local().format('YYYY-MM-DD HH:mm')}~${moment.utc(selectionObject.endDate).local().format('YYYY-MM-DD HH:mm')}`,
          },
          tableConfiguration
        );
      }
      setCurrentDatasource(fetchedCurrentDatasource);
      setReportName(reportName?.file || '');
    } else {
      setCurrentDatasource(fetchedCurrentDatasource);
    }

    // Handle PDF download
    if (props.tableConfiguration?.downloadPdf) {
      let pdfName = '';
      if (props.tableConfiguration.downloadPdfPayload?.summaryType === 'true' && props.childTable?.[0]?.columns) {
        pdfName = await getPdfNametoDownload(
          columns,
          fetchedCurrentDatasource,
          props.tableConfiguration.downloadPdfPayload,
          props.childTable[0].columns,
          childDatasource,
          weekSummaryDatasource
        );
      } else {
        pdfName = await getPdfNametoDownload(
          columns,
          fetchedCurrentDatasource,
          props.tableConfiguration.downloadPdfPayload
        );
      }
      setCurrentDatasource(fetchedCurrentDatasource);
      setPdfName(pdfName?.file || '');
    } else {
      setCurrentDatasource(fetchedCurrentDatasource);
    }
  };

  const multiVariantonChange = async (pagination, filters) => {
    const multiVaraintColumns = cloneDeep(props.nestedChildColumns);

    const filterKeys = Object.keys(filters);
    let filterValues = [];
    let key = [];

    filterKeys?.filter(filterData =>
      filterData && filters[filterData] && filters[filterData] !== null
    ).forEach(filterData => {
      filterValues = [...filterValues, ...filters[filterData]];
      key.push(filterData);
    });

    const name = key[0];

    const res = currentDatasource.filter(el =>
      filterValues.indexOf(el[name]) >= 0
    );

    const reportName = await getReportNametoDownloadMultiVaraint(
      columns,
      res,
      multiVaraintColumns,
      props.tableConfiguration.downloadExcelPayload
    );
    setReportName(reportName?.file || '');
    setCurrentDatasource(res);
    setFilteredInfo(filterValues);
    // setState(prevState => ({
    //   ...prevState,
    //   reportName: reportName?.file || '',
    //   currentDatasource: res,
    //   filteredInfo: filters
    // }));

    _getDataSource();
  };

  const onInputChange = async (columnValue, columnkey, header, index, initialRender) => {
    setSelectedDevice(columnValue);

    let columnsClone = {};
    let newObject = {
      ...tableConfiguration.headerSelection[index],
      defaultValue: columnValue
    };

    delete tableConfiguration.headerSelection[index];
    tableConfiguration.headerSelection = tableConfiguration.headerSelection.filter(header => header);

    let { headerSelection } = tableConfiguration;
    if (headerSelection) {
      let tableConfigurationClone = {
        ...tableConfiguration,
        headerSelection: [...tableConfiguration.headerSelection, newObject]
      };

      let TagsListClone = {};
      tableConfigurationClone &&
        tableConfigurationClone.headerSelection &&
        Array.isArray(tableConfigurationClone.headerSelection) &&
        tableConfigurationClone.headerSelection.forEach((header) => {
          if (header) {
            TagsListClone = {
              ...TagsList,
              [header.key]: header.defaultValue
            };
          }
        });
      await onSelectionChange(TagsListClone);
      if (columnkey === 'isEquipment' && columnValue === 'no') {
        columnsClone = await this.columnValidation(columns, columnValue);
      } else if (columnkey === 'isEquipment' && columnValue === 'yes') {
        columnsClone = await this.columnValidation(columns, columnValue);
      } else {
        columnsClone = cloneDeep(columns);
      }
      setTableConfiguration(prev => ({
        ...prev,
        tableConfiguration,
        // columns,
        // initialRender
      }));
      setColumns(columnsClone);
      setInitalRender(initialRender);
    } else {
      message.warn('error');
    }
  };

  const {
    bordered,
    tableSize,
    noResultMessage,
    isCursorPointer,
    title,
    downloadXLXS,
    downloadPdf,
    headerSelection,
    pagination,
    horizontalScroll,
  } = tableConfiguration;

  const { columnFilter } = props.tableConfiguration || {};
  const { childTable, weekSummaryTable, nestedChildColumns } = props;

  const tProps = {
    treeData: treeData && Array.isArray(treeData) && treeData.filter(
      (e) =>
        e.key !== 'Date' &&
        e.key !== 'Total' &&
        e.key !== 'Total Consumption With Losses' &&
        e.key !== 'Total Cost per KWH' &&
        e.key !== 'Total ATM Consumption(Day-Wise kWh)'
    ),
    value: value.filter(
      (e) =>
        e !== 'Date' &&
        e !== 'Total' &&
        e !== 'Total Consumption With Losses' &&
        e !== 'Total Cost per KWH' &&
        e !== 'Total ATM Consumption(Day-Wise kWh)'
    ),
    onChange: (newValue) => onChange(newValue), // Assuming onChange is defined elsewhere
    treeCheckable: true,
    showCheckedStrategy: SHOW_PARENT,
    searchPlaceholder: 'Select/Unselect',
    dropdownStyle: { maxHeight: 400, overflow: 'auto' },
    style: {
      width: '70%',
      margin: '0px 10px',
    },
  };

  return (
    <div>
      {selectionWidget ? (
        <SelectionComponent
          selectionWidget={selectionWidget}
          selectionpayload={selectionPayloadHandler}
        />
      ) : null}
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          cursor: 'pointer',
          marginBottom: '10px',
          justifyContent: 'flex-end',
        }}
      >
        {headerSelection && Array.isArray(headerSelection) && headerSelection[0] ? (
          <SelectComponennt
            id={0}
            column={headerSelection[0]}
            record={{ key: headerSelection[0].key }}
            {...initalRender}
            handleFieldChange={(e, initialRender, column) =>
              onInputChange(e, headerSelection[0].key, headerSelection[0], 0, initialRender, column) // Assuming onInputChange is defined elsewhere
            }
          />
        ) : null}
      </div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row-reverse',
          cursor: 'pointer',
          marginBottom: '10px',
        }}
      >
        {downloadXLXS && reportName ? (
          <a href={`${IPAddress.LOCAL}${REPORTS.Reports}/${reportName}`}>
            <DownloadOutlined />
          </a>
        ) : null}
        {downloadPdf && pdfName ? (
          <a href={`${IPAddress.LOCAL}${REPORTS.Reports}/${pdfName}`}>
            <FilePdfOutlined />
          </a>
        ) : null}
        {tableConfiguration && tableConfiguration.link
          ? tableConfiguration.link.map((links, index) => (
            <Tag key={index} color="#aaa3a3">
              <Link to={{ pathname: links.path }} style={{ marginRight: '10px' }}>
                {links.name}
              </Link>
            </Tag>
          ))
          : null}
        {columnFilter && (columnFilter === true || columnFilter === 'true') ? (
          <TreeSelect {...tProps} />
        ) : null}
      </div>
      {columns && columns.length >= 0 && !nestedChildColumns ? (
        <StyledTable
          columns={columns}
          dataSource={Array.isArray(currentDatasource) ? currentDatasource : []}
          bordered={bordered || false}
          size={tableSize || 'small'}
          locale={{ emptyText: noResultMessage }}
          isCursorPointer={isCursorPointer === true ? 'not-allowed' : 'pointer'}
          onChange={multiVariantonChange} // Assuming multiVariantonChange is defined elsewhere
          loading={false}
          scroll={horizontalScroll ? { x: 120, y: 550 } : {}}
          pagination={pagination || false}
          title={
            title
              ? () => (
                <div
                  style={{
                    color: 'white',
                    fontWeight: 'bold',
                    textAlign: 'center',
                  }}
                >
                  {title}
                </div>
              )
              : null
          }
        />
      ) : null}

      {columns &&
        columns.length >= 0 &&
        nestedChildColumns &&
        Array.isArray(nestedChildColumns) &&
        nestedChildColumns[0] &&
        nestedChildColumns[0].columns ? (
        <StyledTable
          columns={columns.filter((col) => value.includes(col.key))}
          dataSource={Array.isArray(currentDatasource) ? currentDatasource : []}
          bordered={bordered || false}
          size={tableSize || 'small'}
          locale={{ emptyText: noResultMessage }}
          isCursorPointer={isCursorPointer === true ? 'not-allowed' : 'pointer'}
          onChange={multiVariantonChange} // Assuming multiVariantonChange is defined elsewhere
          loading={false}
          scroll={{ x: 120, y: 550 }}
          pagination={false}
          title={
            title
              ? () => (
                <div
                  style={{
                    color: 'white',
                    fontWeight: 'bold',
                    textAlign: 'center',
                  }}
                >
                  {title}
                </div>
              )
              : null
          }
          expandedRowRender={(record) => (
            <StyledTable size="small"
              columns={
                nestedChildColumns &&
                  Array.isArray(nestedChildColumns) &&
                  nestedChildColumns[0] &&
                  nestedChildColumns[0].columns
                  ? nestedChildColumns[0].columns
                  : []
              }
              dataSource={
                record.multiVariantChildren && Array.isArray(record.multiVariantChildren)
                  ? record.multiVariantChildren
                  : []
              }
              style={{ padding: '25px' }}
              pagination={false}
            />
          )}
        />
      ) : (
        <div />
      )}
      {childTable && childTable[0] && childTable[0].columns && childTable[0].columns.length > 0 ? (
        <ChildTablesGroup>
          <StyledTable
            columns={summaryTable ? summaryTable.filter((col) => summaryValue.includes(col.key)) : []}
            dataSource={Array.isArray(childDatasource) ? childDatasource : []}
            bordered={bordered || false}
            size={tableSize || 'small'}
            locale={{ emptyText: noResultMessage }}
            loading={false}
            style={{ marginTop: '30px' }}
            scroll={{ x: 120, y: 550 }}
            pagination={false}
            title={
              title
                ? () => (
                  <div
                    style={{
                      color: 'white',
                      fontWeight: 'bold',
                      textAlign: 'center',
                    }}
                  >
                    {title}
                  </div>
                )
                : null
            }
          />
        </ChildTablesGroup>
      ) : null}
      {childTable &&
        childTable[0] &&
        childTable[0].columns &&
        childTable[0].columns.length > 0 &&
        weekSummaryTable ? (
        <ChildTablesGroup>
          <StyledTable
            columns={
              summaryTable ? summaryTable.filter((col) => summaryValue.includes(col.key)) : []
            }
            dataSource={weekSummaryDatasource}
            bordered={bordered || false}
            size={tableSize || 'small'}
            locale={{ emptyText: noResultMessage }}
            loading={false}
            style={{ marginTop: '30px' }}
            scroll={{ x: 120, y: 550 }}
            pagination={false}
            title={
              title
                ? () => (
                  <div
                    style={{
                      color: 'white',
                      fontWeight: 'bold',
                      textAlign: 'center',
                    }}
                  >
                    {title}
                  </div>
                )
                : null
            }
          />
        </ChildTablesGroup>
      ) : null}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    translationCache: state.TranslationReducer.translationCache,
  };
};

export default connect(mapStateToProps)(ReportTable);
